// Company: Ajinsoft
// Author: Uilan Coqueiro
// Date: 2024-04-15

export class ApiConfig {
	private static _url: string | null;

	static get url(): string {
		return this._url;
	}

	static setUrl(url: string) {
		this._url = url;
	}

	static concatUrl(value: string): string {
		return `${this._url}${value}`;
	}

	static replaceVersion(version: string) {
		return this._url.replace(/v\d+/, version);
	}
}
